/** Shared prefixes keep list, detail and counts consistent after a lifecycle mutation. */
export const LEARNER_ASSIGNMENT_QUERY_KEY = "learner-assignments";
export const LEARNER_ASSIGNMENT_COUNTS_QUERY_KEY = "learner-assignment-counts";
